import useAppStore from "@/context/store";
import sha1 from "sha1";

let isInitUdesk = false;
const initUdesk = (user, callback) => {
  if (!isInitUdesk) {
    if (!window.ud) {
      (function (a, h, c, b, f, g) {
        a["UdeskApiObject"] = f;
        a[f] =
          a[f] ||
          function () {
            (a[f].d = a[f].d || []).push(arguments);
          };
        g = h.createElement(c);
        g.async = 1;
        g.charset = "utf8";
        g.src = b;
        c = h.getElementsByTagName(c)[0];
        c.parentNode.insertBefore(g, c);
      })(
        window,
        document,
        "script",
        "//assetscli.udesk.cn/im_client/js/udeskApi.js",
        "ud"
      );
    }
    const imUserKey = "5f4ccb0eae5588fe36c8f8c797bd83fe";
    const code = "5f4ccb0eae5588fe36c8f8c797bd83fe";
    const link =
      "https://ttxsapp.udesk.cn/im_client/?web_plugin_id=98162&language=zh-cn";
    const isLogin = user;
    const config = {
      code: code,
      link: link,
      mode: "inner",
      mobile: {
        mode: "blank",
        noBubble: true,
      },
      panel: {
        css: {
          right: "20px",
        },
      },
      css: {
        width: "0px",
        height: "0px",
        overflow: "hidden",
      },
      language: "zh-cn",
      onReady: function () {
        callback && callback();
      },
    };
    if (isLogin) {
      let nonce = "";
      while (nonce.length < 14) {
        const n = Math.floor(Math.random() * 62);
        if (n < 10) nonce += n;
        else if (n < 36) nonce += String.fromCharCode(n + 55);
        else nonce += String.fromCharCode(n + 61);
      }
      const timestamp = +new Date();
      const name = user.username;
      const urlname = user.urlname;
      const webToken = user.user_id;
      config.customer = {
        c_cf_entrance: "花瓣",
        "c_cf_web UID": webToken,
        c_cf_对话页面: window.location.href,
        c_cf_咨询信息: "用户个人主页：https://huaban.com/user/" + urlname,
        c_name: name,
        nonce: nonce,
        signature: sha1(
          "nonce=" +
            nonce +
            "&timestamp=" +
            timestamp +
            "&web_token=" +
            webToken +
            "&" +
            imUserKey
        )
          .toString()
          .toUpperCase(),
        timestamp: timestamp,
        web_token: webToken,
      };
    }
    window.ud(config);
    isInitUdesk = true;
  } else {
    callback && callback();
  }
};

export default initUdesk;

export function openUdesk() {
  initUdesk(useAppStore.getState().user, () => {
    window.ud && window.ud.showPanel();
  });
}
